import React from "react";
import Header from "../../components/General/Header";
import Footer from "../../components/General/Footer";
import Cta from "../../components/General/Cta";
import CaseStudyHeader from "../../components/CaseStudy/CaseStudyHeader";
import CaseStudyDetail from "../../components/CaseStudy/CaseStudyDetail";
import Approach from "../../components/CaseStudy/Approach";

const CaseStudy = () => {
  return (
    <>
      <Header />
      <CaseStudyHeader />
      <Approach />
      <CaseStudyDetail />
      <Cta
        bigTitle={"Get started today with a 30min intro call"}
        smallTitle={
          "We'll analyze your current processes and provide you with a free analysis on how to optimize your agency - no strings attached. Get tens of thousands of dollars of value, absolutely free."
        }
        buttonText={"Scale my Company →"}
      />
      <Footer />
    </>
  );
};

export default CaseStudy;
